import PackForm from '../components/PackForm';
import FORM_TYPES from '../lib/formTypes';

function NewPackForm() {
  return <PackForm formType={FORM_TYPES.new} />;
}
export default NewPackForm;
